var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkChain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6668 8.66404C6.9531 9.04679 7.31837 9.36349 7.73783 9.59267C8.1573 9.82184 8.62114 9.95812 9.0979 9.99226C9.57466 10.0264 10.0532 9.95762 10.501 9.79056C10.9489 9.6235 11.3555 9.36209 11.6935 9.02404L13.6935 7.02404C14.3007 6.39537 14.6366 5.55336 14.629 4.67937C14.6215 3.80538 14.2709 2.96934 13.6529 2.35131C13.0348 1.73328 12.1988 1.38272 11.3248 1.37513C10.4508 1.36753 9.60881 1.70351 8.98013 2.31071L7.83347 3.45071M9.33347 7.33071C9.04716 6.94795 8.68189 6.63125 8.26243 6.40208C7.84297 6.17291 7.37913 6.03663 6.90237 6.00248C6.4256 5.96834 5.94708 6.03713 5.49924 6.20419C5.0514 6.37124 4.64472 6.63266 4.3068 6.97071L2.3068 8.97071C1.69961 9.59938 1.36363 10.4414 1.37122 11.3154C1.37881 12.1894 1.72938 13.0254 2.3474 13.6434C2.96543 14.2615 3.80147 14.612 4.67546 14.6196C5.54945 14.6272 6.39146 14.2912 7.02013 13.684L8.16013 12.544",
    stroke: "#828282",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkChain);
export default __webpack_public_path__ + "static/media/link-chain.3f2622732ecbc51a136013eb8d82446e.svg";
export { ForwardRef as ReactComponent };